<template>
	<div class="container">
		<div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle">  <div class="innerLine">账号信息</div>							</div>
				<div class="panelContent">
					<div class="oneRow">
						<div class="oneCol third"> 
                            <viewer :images="headPicArr">
                                <img :src="IMG_PREV+headPic" alt="" class="headerLogo" v-if="headPic" >
                            </viewer>
							<img src="../../assets/images/icon/icon_person.png" alt="" class="headerLogo" v-if="!headPic">
							<div class="label">注册手机号</div>
							<div class="desc">{{infoObj.user_cellphone}}</div>
						</div>
						<div class="oneCol third">
							<div class="label justify">身份</div>
							<div class="desc">{{infoObj.user_type | turnValToText("user_type")}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 第2块 -->
			<div class="panelBlock">
				<div class="panelTitle">  
					<div class="innerLine">
						企业基础信息    
						<span>
							<span :class="{green:infoObj.auth_result=='y',red:infoObj.auth_result=='n',orange:infoObj.auth_result=='p'}">
								 ({{infoObj.auth_result | turnValToText("auth_result")}})
							</span>
							<span v-if="!infoObj.auth_result">(未提交审核资料)</span>
							{{djs}}
						</span>
						
					</div>		
				</div>
				<div class="panelContent">
					<div class="oneRow">
						<div class="oneCol third"> 
							<div class="label">公司名称</div>
							<div class="desc">{{infoObj.company_name}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">公司电话</div>
							<div class="desc">{{infoObj.company_phone}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">公司地址</div>
							<div class="desc">{{infoObj.company_province}}{{infoObj.company_city}}{{infoObj.company_district}}</div>
						</div>
					</div>
					<div class="oneRow">
						<div class="oneCol third" v-if="infoObj.user_type==2"> 
							<div class="label">法定代表人</div>
							<div class="desc">{{infoObj.company_key_person}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">营业执照号</div>
							<div class="desc">{{infoObj.company_license_number}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">上次登录时间</div>
							<div class="desc">{{infoObj.lastLoginTime}}</div>
						</div>
						
					</div>
					<div class="oneRow highRow">
						<div class="oneCol third">
							<div class="label">营业执照</div>
							<div class="desc">
                                <viewer :images="licenseFileArr">
                                    <img :src="IMG_PREV+licenseFile" alt="" class="pic">

                                </viewer>
                            </div>
						</div>
						<div class="oneCol auto" v-if="infoObj.user_type==2">
							<div class="label">工厂图片</div>
							<div class="desc">
                                <viewer :images="userAuthFactoryPicArr">    
                                    <img :src="IMG_PREV+list.image_file" alt="" class="pic" v-for="list in userAuthFactoryPic">
                                </viewer>
							</div>

						</div>
					</div>
				</div>
			</div>
			<!-- 第3块 -->
			<div class="panelBlock">
				<div class="panelTitle">  <div class="innerLine">企业业务信息</div>							</div>
				<div class="panelContent">
					<div class="oneRow" v-if="infoObj.user_type==2">
						<div class="oneCol third"> 
							<div class="label">主要品质产出</div>
							<div class="desc">
								<span class="item" v-for="list in mainQuantityStr.list" v-if="list.isSelect==1">{{list.dataName}}</span>
							</div>
						</div>
						<!-- <div class="oneCol third">
							<div class="label">是否有供款</div>
							<div class="desc">-</div>
						</div> -->
						<div class="oneCol third">
							<div class="label long">是否有采购面料的能力</div>
							<div class="desc">
								<span v-if="canBuyFabricAbility">是</span>
								<span v-if="!canBuyFabricAbility">否</span>
							</div>
						</div>
					</div>
                    <div class="oneRow" v-if="infoObj.user_type==1">
                    	<div class="oneCol third"> 
                    		<div class="label">业务负责人</div>
                    		<div class="desc">
                    			{{infoObj.company_key_person}}
                    		</div>
                    	</div>
                    	<div class="oneCol third"> 
                    		<div class="label">负责人电话</div>
                    		<div class="desc">
                    			{{infoObj.company_key_person_phone}}
                    		</div>
                    		
                    	</div>
                    	
                    	
                    </div>
					<div class="oneRow" v-if="infoObj.user_type==1">
						<div class="oneCol third"> 
							<div class="label">主营渠道</div>
							<div class="desc">
								<span v-for="list in channelList" v-if="list.isSelect==1" class="item chanelItem">
									{{list.dataName}}
								</span>
							</div>
						</div>
						<div class="oneCol third"> 
							<div class="label justify">品牌</div>
							<div class="desc">
								{{infoObj.company_brand}}
							</div>
							
						</div>
						
						
					</div>
					<div class="oneRow multi">
						<div class="oneCol"> 
							<div class="label">主营品类</div>
							<div class="desc ">
								<ul>
									<li v-for="list in product" v-if="list.checked">
										<span class="item">{{list.dataName}} ：</span>
										<span class="item" v-for="list2 in list.list" v-if="list2.checked">{{list2.name}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="oneRow multi" v-if="infoObj.user_type==2">
						<div class="oneCol auto"> 
							<div class="label long">所能处理的加工环节</div>
							<div class="desc">
								<span class="item processItem" v-for="list in handleNeedProcessingLink.list" v-if="list.isSelect==1">{{list.dataName}}</span>
								<span class="item processItem " v-if="handleNeedProcessingLink.other">{{handleNeedProcessingLink.other}}</span>
							</div>
						</div>
                        <div class="oneCol auto"> 
                        	<div class="label long">所能处理的特殊工艺</div>
                        	<div class="desc">
                        		<span class="item processItem" v-for="list in handleSpecialProcess.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                        		<span class="item processItem" v-if="handleSpecialProcess.other">{{handleSpecialProcess.other}}</span>
                        	</div>
                        </div>
					</div>
					
					<div class="oneRow"  v-if="infoObj.user_type==2">
						<div class="oneCol"> 
							<div class="label">员工总人数</div>
							<div class="desc" v-if="!staffInfo.employeeData.total">
								{{staffNumber}}人
							</div>
							<div class="desc" v-if="staffInfo.employeeData.total">
								<span class="item">{{staffInfo.employeeData.total}} 人</span>
								(<span class="item" v-for="list in staffInfo.employeeData.childrenLists">
									{{list.name}} {{list.num}} 人
 								</span>)
								
							</div>
						</div>
					</div>
					<div class="oneRow" v-if="infoObj.user_type==2">
						<div class="oneCol"> 
							<div class="label">设备总数</div>
							<div class="desc" v-if="staffInfo.machineData.total">
								<span class="item">{{staffInfo.machineData.total}} 人</span>
								(<span class="item" v-for="list in staffInfo.machineData.childrenLists">
									{{list.name}} {{list.num}} 台
								</span>)
								
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 第4块 -->
			<div class="panelBlock" >
				<div class="panelTitle">  <div class="innerLine">其他信息</div>							</div>
				<div class="panelContent" style="padding-bottom: 1rem;">
					<div class="oneRow">
						<div class="oneCol third"> 
							<div class="label">注册渠道</div>
							<div class="desc">{{infoObj.token_type | turnValToText("token_type")}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">注册时间</div>
							<div class="desc">{{infoObj.user_register_time}}</div>
						</div>
						<div class="oneCol third">
							<div class="label">认证状态</div>
							<div class="desc">
								<span :class="{green:infoObj.auth_result=='y',red:infoObj.auth_result=='n',orange:infoObj.auth_result=='p'}">{{infoObj.auth_result | turnValToText("auth_result")}}</span>
								<span v-if="!infoObj.auth_result">未提交审核资料</span>
								<el-button type="primary" @click="openAuth" v-if="infoObj.auth_result=='p'&&functionCustomerIdentityAuth" size="mini">审核企业信息</el-button>
							</div>
						</div>
					</div>
					<div class="oneRow multi">
						<div class="oneCol auto "> 
							<div class="label">审核记录</div>
							<div class="desc greyThead">
								<el-table  stripe :data="userAuthRecordList" tooltip-effect="dark" style="width: 100%">
									<el-table-column label="序号" width="50">
										<template slot-scope="scope">{{scope.$index+1}}</template>
									</el-table-column>
									<el-table-column label="认证审核操作账号" width="140">
										<template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
									</el-table-column>
									<el-table-column label="提交认证时间" width="170">
										<template slot-scope="scope">{{ scope.row.auth_user_submit_time }}</template>
									</el-table-column>
									<el-table-column label="认证审核时间" width="170">
										<template slot-scope="scope">{{ scope.row.auth_admin_submit_time }}</template>
									</el-table-column>
									<el-table-column label="认证结果" width="170">
										<template slot-scope="scope">{{ scope.row.auth_result |turnValToText("auth_result")}}</template>
									</el-table-column>
										<el-table-column label="说明" >
										<template slot-scope="scope">{{ scope.row.auth_reject_causation }}</template>
									</el-table-column>
									
								</el-table>
								
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
		<!-- <el-dialog	custom-class="prevImgModal"  title="图片预览"	center	  :visible.sync="isShowImgModal"	top="3vh"  >
		  <div class="prevImgModalContent">		  <img :src="IMG_PREV+currentPrevImg" alt="">		  </div>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="isShowImgModal = false">关闭</el-button>
		  </span>
		</el-dialog> -->

		<authmodal :current="currentAuthList" :isShow="isShowModal" @close="closeModal" @submitSucess="refreshPage"></authmodal>
		<!-- <div class="ceshi">
			ceshi:
		</div> -->
	</div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    import authmodal from '@/components/authModal.vue'
    export default {
        name: 'adminIndex',
        data() {
            return {
                // currentPrevImg: '',
                isLoading: false,
                authId: "",
                djs: "",
                userId: "",
                headPic: "",
                headPicArr:[],
                licenseFile: "",
                licenseFileArr:[],
                userAuthFactoryPic: [],
                userAuthFactoryPicArr:[],
                infoObj: {},
                regStrObj: {},
                canBuyFabricAbility: "",
                mainQuantityStr: [],
                handleNeedProcessingLink: [],
                handleSpecialProcess: [],
                product: [], //主营品类
                channelList: [], //主营渠道
                staffNumber: "",
                staffInfo: {
                    employeeData: {},
                    machineData: {}
                },
                userAuthRecordList: [],
                isShowModal: false, //审核的modal
                isShowImgModal: false, //图片预览
                currentAuthList: {},
                timer: '',

            }
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            functionCustomerIdentityAuth(){
                return utils.getCurrentFunction().indexOf("customerIdentityAuth")>-1
            },
        },
        components: {
            authmodal
        },
        methods: {
            // prevImg(url) {
            //     this.isShowImgModal = true
            //     this.currentPrevImg = url
            // },
            
            getDjs() {
                let _this = this
                let endDate = this.infoObj.auth_user_submit_time
                if (endDate && _this.infoObj.auth_result == 'p') {
                    _this.timer = setInterval(function() {
                        console.log(_this.timer)
                        _this.djs = utils.computeDjs(endDate, 2)
                    }, 1000)
                }


            },
            back() {
                this.$router.back()
            },
            closeModal() {
                this.isShowModal = false
            },
            openAuth() {
                let list = {
                    company_name: this.infoObj.company_name,
                    user_id: this.infoObj.user_Id,
                    auth_id: this.infoObj.auth_id
                }
                this.currentAuthList = list
                this.isShowModal = true
            },
            refreshPage(){
                 this.getParam()
                this.getDetail()
            },
            getParam() {
                this.userId = this.$route.params.userId
            },
            getDetail() {
                
                let _this = this
                _this.isLoading = true
                let args = {
                    userId: _this.userId,
                }
                ajaxPost('/admin/getUserListDetail', args).then(function(res) {
                    _this.isLoading = false

                    if (res.data) {
                        //基础信息加图片
                        _this.infoObj = res.data.userAuthDetail ? res.data.userAuthDetail : {}
                        _this.infoObj.user_type = _this.infoObj.userType
                        //品牌
                        if (_this.infoObj.company_brand) {
                            let arr = _this.infoObj.company_brand.split(",")
                            _this.infoObj.company_brand = arr.join(" / ")
                        }

                        _this.userId = _this.infoObj.user_id
                        _this.headPic = res.data.headPic
                        
                        _this.headPicArr.push(_this.IMG_PREV+_this.headPic)
                        
                        _this.licenseFile = res.data.licenseFile
                        _this.licenseFileArr.push(_this.IMG_PREV+_this.licenseFile)
                        _this.staffNumber = res.data.staffNumber
                        _this.imgFile = res.data.imgFile
                        _this.userAuthFactoryPic = res.data.userAuthFactoryPic || []
                        _this.userAuthFactoryPicArr=_this.userAuthFactoryPic.map(function(item,index){
                            return  _this.IMG_PREV+item.image_file
                        })
                        _this.userAuthRecordList = res.data.userAuthRecordList || []
                        //regStr
                        if (res.data.regStr) {
                            _this.regStrObj = JSON.parse(res.data.regStr)
                            console.log(_this.regStrObj)
                            _this.product = _this.regStrObj.product
                            _this.channelList = _this.regStrObj.channel ? _this.regStrObj.channel.list : []
                        }
                        if (res.data.staffInfo) {
                            _this.staffInfo = JSON.parse(res.data.staffInfo)

                        }
                        if (res.data.staffDevice) {
                            console.log(newObj, "newObj")
                            let newObj = JSON.parse(res.data.staffDevice)
                            _this.canBuyFabricAbility = newObj.canBuyFabricAbility
                            _this.mainQuantityStr = newObj.mainQuantityStr
                            _this.handleSpecialProcess = newObj.handleSpecialProcess
                            _this.handleNeedProcessingLink = newObj.handleNeedProcessingLink

                        }
                        console.log(_this.staffInfo, "设备、人员")
                        //倒计时
                        _this.getDjs()

                    }




                }, function(res) {
                    _this.isLoading = false
                })
            },

        },
        mounted() {
            let _this = this
           this.refreshPage()
        },
        destroyed() {
            let _this = this
            console.log(_this.timer, "销毁定时器")
            clearInterval(_this.timer)


        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }

    .item {
        margin-right: 0.2rem;
    }

    .contentWrap {
        padding: 0.15rem 0.5rem;
    }

    .headerLogo {
        width: 0.7rem;
        height: 0.7rem;
        margin-right: 1rem;
    }

    .panelBlock {

        //主营渠道后加斜杠
        .chanelItem,
        .processItem {
            margin-right: 0;
        }

        .chanelItem:not(:last-child)::after,
        .processItem:not(:last-child)::after {
            content: "  / "
        }

        .pic {
            max-height: 100%;
            width: auto;
            min-width: 2rem;
            height: 2rem;
            background: #eee;
            margin-right: 0.2rem;
        }

        .panelTitle {
            padding: 0.7rem 0 0.3rem;
            color: #4C4C4C;

            .innerLine {
                border-left: 4px solid lightblue;
                font-size: 17px;
                padding-left: 0.25rem;
            }
        }

        .panelContent {
            background: #fff;
            padding: 0.4rem 0;
            font-size: 14px;

            .oneRow.highRow {
                height: 2rem;
            }

            .oneRow.multi {
                height: auto;
            }

            .oneRow {
                display: flex;
                height: 0.7rem;
                line-height: 0.7rem;
                padding: 0.1rem;
                padding-left: 0.5rem;

                .oneCol.third {
                    width: 33%;
                }

                .oneCol.auto {
                    flex: 1;
                }

                // .oneCol.auto{flex:1;}
                .oneCol {
                    display: flex;

                    .label.long {
                        width: 4rem;
                    }

                    .label {
                        color: #aaa;
                        padding: 0 0.2rem;
                        width: 2.5rem;
                    }

                    .label.justify {
                        text-align: justify;
                        text-align-last: justify;
                        width: 1.4rem;
                        margin-right: 1.1rem;
                    }

                    .desc {
                        color: #3a3a3a;
                        display: flex;
                        flex: 1;
                    }

                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/detail.vue